var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 58 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xD0\xA0\xD0\xB5\xD0\xB6\xD0\xB8\xD0\xBC_\xD0\xB8\xD0\xB7\xD0\xBE\xD0\xBB\xD1\x8F\xD1\x86\xD0\xB8\xD0\xB8",
    clipPath: "url(#clip0_23_5875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 60L58 30L0 0L27.9851 30L0 60Z",
    fill: "#FFFAF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_5875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendArrow);
export default __webpack_public_path__ + "static/media/send-arrow.952f7720e43b87c33363e82bc6fbfcf1.svg";
export { ForwardRef as ReactComponent };